'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    sidebar: {
      maxWidth: '100%',
      boxShadow: theme.boxShadow(0),
      background: 'inherit',
      padding: '0 12px',
      boxSizing: 'border-box',
      transition: theme.transition(['all']),
      cursor: 'default',
      borderRadius: 0,
      overflow: 'initial',
      maxHeight: 'initial',
      '& > *:not(:first-child)': {
        margin: '9px 0 0 0'
      }
    },
    menuItem: {
      borderRadius: theme.sideBar.item.borderRadius,
      minHeight: 28,
      padding: '2px 12px 2px 24px',
      boxSizing: 'border-box',
      backgroundColor: theme.sideBar.item.bgColor,
      '& > div > span': {
        // label
        color: theme.sideBar.item.textColor
      },
      '& > i:first-child': {
        // left icon
        marginRight: 12
      },
      '&:hover': {
        backgroundColor: theme.sideBar.item.bgHoverColor
      },
      '&.active': {
        cursor: 'default',
        backgroundColor: theme.sideBar.item.bgActiveColor,
        '& > i:first-child .fill': {
          // left icon
          fill: theme.sideBar.item.iconActiveColor
        },
        '& > div > span': {
          // label
          color: theme.sideBar.item.textActiveColor
        }
      },
      '& .badge': {
        padding: '0 2px',
        boxSizing: 'border-box',
        width: 'auto',
        marginLeft: 24
      }
    },
    // styles for NavLink wrapper
    navMenuItem: {
      display: 'block',
      cursor: 'default',
      '& > div': {
        borderRadius: theme.sideBar.item.borderRadius,
        minHeight: 28,
        padding: '2px 12px 2px 24px',
        boxSizing: 'border-box',
        backgroundColor: theme.sideBar.item.bgColor,
        '& > div > span': {
          // label
          color: theme.sideBar.item.textColor
        },
        '&:hover': {
          backgroundColor: theme.sideBar.item.bgHoverColor
        },
        '& > i:first-child': {
          // left icon
          marginRight: 12
        },
        '& .badge': {
          padding: '0 2px',
          boxSizing: 'border-box',
          width: 'auto',
          marginLeft: 24
        }
      },
      '&.active': {
        '& > div, & > div:hover': {
          cursor: 'default',
          backgroundColor: theme.sideBar.item.bgActiveColor,
          '& > i:first-child .fill': {
            // left icon
            fill: theme.sideBar.item.iconActiveColor
          },
          '& > div > span': {
            // label
            color: theme.sideBar.item.textActiveColor
          }
        }
      }
    }
  };
};